import React, { Component } from 'react';
import Loading from '../Loading/Loading';
import './UserCompanyLogin.scss';

export default class UserCompanyLogin extends Component<{
    // props
    isTransparent: boolean;
    enablePodRedirection: boolean;
    returnToCurrentServiceAfterRegistration: boolean;
    returnUrlQueryString: string;
    registrationSource: string;
    scrolled: boolean;
}, {
    // state
    open: boolean;
    loginWrapperRef: any;
    MenuComponent: any; // Add MenuComponent to state to store the dynamically loaded component
}> {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loginWrapperRef: '',
            MenuComponent: null, // Initialize MenuComponent as null
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.setGetStartedWrapperRef = this.setGetStartedWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    private setGetStartedWrapperRef(node) {
        this.setState({
            loginWrapperRef: node,
        });
    }

    private toggleMenu() {
        // If menu is being opened and MenuComponent is not loaded yet, load it
        if (!this.state.open && !this.state.MenuComponent) {
            // Use dynamic import to load the Menu component on demand
            import('./Menu/Menu')
                .then((module) => {
                    this.setState({
                        MenuComponent: module.default,
                    });
                })
                .catch((error) => {
                    console.error('Failed to load Menu component:', error);
                });
        }
        this.setState({
            open: !this.state.open,
        });
    }

    private closeMenu() {
        this.setState({ open: false });
    }

    private handleClickOutside(event) {
        if (this.state.open) {
            if (this.state.loginWrapperRef && !this.state.loginWrapperRef.contains(event.target)) {
                this.closeMenu();
            } else {
                return false;
            }
        }
    }

    public render() {
        const { isTransparent, scrolled } = this.props;
        const { MenuComponent } = this.state;

        const userCompanyLoginStyles = () => {
            const isScrolled = this.props.scrolled ? ' -scrolled' : '';
            return `user-company-login${isScrolled}`;
        };

        const buttonStyles = () => {
            const isT = isTransparent ? ' -transparent' : '';
            const isScrolled = scrolled ? ' -scrolled' : '';
            return `user-company-login__button${isT}${isScrolled}`;
        };

        return (
            <div className={`${userCompanyLoginStyles()}`} ref={this.setGetStartedWrapperRef}>
                <div className={buttonStyles()}
                     onClick={this.toggleMenu}
                     data-analytics="Branding-Tools-GetStarted">Does my company subscribe?</div>
                {
                    this.state.open && (
                        MenuComponent ? (
                            <MenuComponent
                                active={this.state.open}
                                title={''}
                                enablePodRedirection={this.props.enablePodRedirection}
                                returnToCurrentServiceAfterRegistration={this.props.returnToCurrentServiceAfterRegistration}
                                returnUrlQueryString={this.props.returnUrlQueryString}
                                registrationSource={this.props.registrationSource}
                            />
                        ) : (
                            <Loading />
                        )
                    )
                }
            </div>
        );
    }
}
